import { getTimeDifferenceInDays, setDefaultTimezone } from '../../helpers/formatters'
import { Activity } from '../../models/note'
import { DriverStatus, DriverStatusToHumanReadable } from '../../models/user'
import { SuspendedDriverReasons } from '../../models/userTimeline'
import { cyanD1, darkGray, errorD1, lightGray1, midGray, primaryBlack } from '../../theme/colors'
import { FlexBox } from '../Base/FlexBox'
import { TextClamp } from '../Base/TextFormat'
import { Dot } from '../Dot/Dot'
import { Text } from '../Text/Text'
import { NoteWrap, NoteWrapDivider, NoteWrapInner } from './NoteItem'

interface ActivityItemProps {
  activity: Activity
}

export function ActivityItem({ activity }: ActivityItemProps) {
  return (
    <NoteWrap>
      <NoteWrapDivider />
      <NoteWrapInner>
        {getStatusHeader(activity)}
        <Text variant="label3" fontColor={darkGray}>
          {activity.statusReason}
        </Text>

        <FlexBox alignItems="center" justifyContent="space-between" mt={1} gap="5px">
          <Text variant="label3" fontColor={midGray} styles="max-width: 40%;">
            <TextClamp>{activity.updatedBy?.email?.split('@')[0]}</TextClamp>
          </Text>
          <Text variant="label3" fontColor={lightGray1}>
            {setDefaultTimezone(activity.dateStart).toLocaleString({
              day: 'numeric',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              timeZoneName: 'short',
            })}
          </Text>
        </FlexBox>
      </NoteWrapInner>
    </NoteWrap>
  )
}

const getStatusHeader = (history: Activity) => {
  const userReadableStatusDetail =
    history.statusDetail && Object.keys(SuspendedDriverReasons).includes(history.statusDetail)
      ? SuspendedDriverReasons[history.statusDetail]['name']
      : ''

  let title = ''
  const userReadableStatus = DriverStatusToHumanReadable[history.status]
  const isStatusDotRed = [DriverStatus.SUSPENDED_TEMPORARILY, DriverStatus.DEACTIVATED].includes(
    history.status
  )

  if (history.dateEnd) {
    const duration = getTimeDifferenceInDays(history.dateStart, history.dateEnd)
    title = `${duration}-day suspension${userReadableStatusDetail ? ` - ${userReadableStatusDetail}` : ''}`
  } else {
    title = `${userReadableStatus}${
      history.status === DriverStatus.SUSPENDED_TEMPORARILY && userReadableStatusDetail
        ? ` - ${userReadableStatusDetail}`
        : ''
    }`
  }

  return (
    <FlexBox gap="5px" alignItems="center" mb={1}>
      <Dot background={isStatusDotRed ? errorD1 : cyanD1} mt={-0.4} />
      <Text variant="header4" color={primaryBlack}>
        {title}
      </Text>
    </FlexBox>
  )
}
